// extracted by mini-css-extract-plugin
export var cartContainer = "_q4-4";
export var gray = "_q4-1";
export var itemContainer = "_q4-2";
export var itemDetails = "_q4-3";
export var strong = "_q4-0";